import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { DayModalData } from '../../models';
import { AttendanceModalComponent } from '../attendance-modal/attendance-modal.component';

@Component({
  selector: 'app-turno-modal',
  templateUrl: './turno-modal.component.html',
  styleUrls: ['./turno-modal.component.scss'],
})
export class TurnoModalComponent {
  readonly NOT_CLASS_DAY_TOOLTIP = 'No es el día de esta clase';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DayModalData,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<TurnoModalComponent>
  ) {}

  get isAttendanceRegistered(): boolean {
    return this.data.attendanceRegistered === true;
  }

  get canShowAttendanceButton(): boolean {
    return !!this.data.classType && this.data.attendanceRegistered === false;
  }

  get isClassDay(): boolean {
    return this.data.classDate === this.today();
  }

  close(): void {
    this.dialogRef.close();
  }

  openAttendanceModal(): void {
    if (!this.canShowAttendanceButton || !this.isClassDay) {
      return;
    }

    this.dialog
      .open(AttendanceModalComponent, {
        width: '400px',
        disableClose: true,
        data: {
          trainingId: this.data.trainingId,
        },
      })
      .afterClosed()
      .subscribe((isAttendanceRegistered: boolean) => {
        if (isAttendanceRegistered) {
          this.data.attendanceRegistered = true;
          this.dialogRef.close(true);
        }
      });
  }

  private today(): string {
    const now = new Date();
    const month = `${now.getMonth() + 1}`.padStart(2, '0');
    const day = `${now.getDate()}`.padStart(2, '0');
    return `${now.getFullYear()}-${month}-${day}`;
  }
}
